<template>
  <label class="flex items-center text-sm text-gray-700 inline-block mb-2">
    <slot />
  </label>
</template>

<script>

export default {
  name: 'FormInputLabel'
}

</script>
